import { Select, ConfigProvider } from "antd";
import "./styles.css";

const EditProfileMultipleSelect = (props) => {
  return (
    <div className="edit-profile-input">
      <ConfigProvider
        theme={{
          components: {
            Select: {
              activeBorderColor: "transparent",
              activeOutlineColor: "transparent",
              hoverBorderColor: "transparent",
              colorBorder: "transparent",
              colorBorderDisabled: "transaprent",
              colorBgBase: "transaprent",
            },
          },
        }}
      >
        <Select
          {...props}
          suffixIcon={null}
          mode="multiple"
          placeholder="Please select"
          className="edit-profile-select-multiple"
        >
          {props?.data?.map((item, index) => {
            return (
              <Select.Option key={index} value={item.value}>
                {item.label}
              </Select.Option>
            );
          })}
        </Select>
      </ConfigProvider>
    </div>
  );
};

export default EditProfileMultipleSelect;
